// extracted by mini-css-extract-plugin
export default {"Container":"Attachments_Container__chx14","Item":"Attachments_Item__mPhOf","Remove":"Attachments_Remove__zL7tx","Uploading":"Attachments_Uploading__DzqqK"};